var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "style-bar py-1 flex-row d-flex space-between"
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-grow-1"
  }, [_vm.isEnabled('fontSize') ? _c('font-size', {
    ref: "fontSize",
    staticClass: "ml-2",
    attrs: {
      "styles": _vm.localStyles,
      "default-size": _vm.defaultFontSize
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }) : _vm._e(), _vm.isEnabled('color') ? _c('font-color', {
    ref: "color",
    staticClass: "ml-2",
    attrs: {
      "css-key": "color",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }) : _vm._e(), _vm.isEnabled('background') ? _c('font-color', {
    ref: "background",
    staticClass: "ml-2",
    attrs: {
      "css-key": "background",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }) : _vm._e(), _vm.isEnabled('textAlign') ? _c('font-alignement', {
    ref: "textAlign",
    staticClass: "ml-2",
    attrs: {
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }) : _vm._e()], 1), _vm._t("actions"), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-icon', _vm._g({
          staticClass: "mr-3",
          attrs: {
            "color": "black"
          },
          on: {
            "click": function click($event) {
              return _vm.clearFormatting();
            }
          }
        }, on), [_vm._v("mdi-format-clear")])];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('restore_default_style')))])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }